
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalFull as ObiBatteryVerticalFullElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-full.js';
 
 
 

 
 export const ObiBatteryVerticalFull = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-full',
   elementClass: ObiBatteryVerticalFullElement,
   events: {
     
   }
  });
 
 